const { useSelector } = require("react-redux");
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { PROVIDER_DATA } from 'utils/homologacion/contants';
import { getContentListV1 } from 'utils/homologacion/homologacion';

export const useShowOverlayTitle = contentInfo => {

    const titleConfig = useSelector(
        selectMetadataKeyByRegion('poster_title_configuration'),
    );
    const normalizeProvider = getContentListV1?.provider(contentInfo, PROVIDER_DATA?.CODE)
        ?.toLowerCase()
        ?.replace(' ', '');

    const titleProviderConfig =
        titleConfig?.[normalizeProvider] || titleConfig.default;

    const titleEnable = titleProviderConfig?.vertical;
    const showOverlay =
        titleEnable &&
        !getContentListV1?.IsLive(contentInfo) &&
        getContentListV1?.provider(contentInfo, PROVIDER_DATA?.CODE) !== 'amco';

    return { showOverlay }
};
